import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42f4e9c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement du résultat...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle text-warning",
  style: {"font-size":"50px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-3" }, "Aucun résultat disponible", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Vous n'avez pas encore composé pour cette évaluation.", -1))
const _hoisted_11 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-hourglass-half text-warning",
  style: {"font-size":"50px"}
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-3" }, "Correction en cours", -1))
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "mb-20" }
const _hoisted_18 = { class: "row g-3" }
const _hoisted_19 = { class: "col-6 col-md-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "result-label" }, "Score", -1))
const _hoisted_21 = { class: "col-6 col-md-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "result-label" }, "Pourcentage", -1))
const _hoisted_23 = {
  key: 0,
  class: "col-6 col-md-3"
}
const _hoisted_24 = { class: "result-card result-success" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "result-label" }, "Bonnes réponses", -1))
const _hoisted_26 = { class: "result-value text-success" }
const _hoisted_27 = {
  key: 1,
  class: "col-6 col-md-3"
}
const _hoisted_28 = { class: "result-card result-danger" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "result-label" }, "Mauvaises réponses", -1))
const _hoisted_30 = { class: "result-value text-danger" }
const _hoisted_31 = {
  key: 0,
  class: "alert alert-warning text-center mt-30"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o fa-3x mb-3" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold" }, "Réponses détaillées non disponibles", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " Les réponses détaillées seront visibles après la date de fin de soumission. ", -1))
const _hoisted_35 = { class: "fw-bold text-dark mb-0" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar me-2" }, null, -1))
const _hoisted_37 = {
  key: 1,
  class: "text-start mt-30"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-20 text-center" }, "Revue détaillée de vos réponses", -1))
const _hoisted_39 = { class: "questions-review" }
const _hoisted_40 = { class: "question-header px-15 py-10 bg-light" }
const _hoisted_41 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_42 = { class: "mb-0 fw-bold" }
const _hoisted_43 = { class: "fw-bold text-primary" }
const _hoisted_44 = { class: "question-content p-15 bg-white" }
const _hoisted_45 = { class: "fw-semibold mb-10 text-black" }
const _hoisted_46 = { class: "user-answer mb-10 p-10 rounded bg-light" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Votre réponse :", -1))
const _hoisted_48 = {
  class: "mb-0 mt-5",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_49 = {
  key: 0,
  class: "p-10 bg-info-subtle rounded"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Commentaire du professeur :", -1))
const _hoisted_51 = { class: "mb-0 mt-5" }
const _hoisted_52 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_53 = { class: "mb-0 fw-bold" }
const _hoisted_54 = { class: "question-content p-15 bg-white" }
const _hoisted_55 = { class: "fw-semibold mb-10 text-black" }
const _hoisted_56 = { class: "user-answer mb-10 p-10 rounded bg-light" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-black" }, "Votre réponse :", -1))
const _hoisted_58 = {
  key: 0,
  class: "correct-answer-display p-10 rounded"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-blue" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check me-1" }),
  /*#__PURE__*/_createTextVNode("Bonne réponse :")
], -1))
const _hoisted_60 = { class: "ms-2 text-blue fw-bold" }
const _hoisted_61 = { class: "actions-zone mt-30" }
const _hoisted_62 = {
  key: 0,
  class: "retry-banner"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "retry-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Vous pouvez recommencer cette composition ! ")
], -1))
const _hoisted_64 = { class: "retry-text" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "retry-note" }, "Seule la note du dernier essai sera retenue.", -1))
const _hoisted_66 = { class: "actions-buttons" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh me-2" }, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-list me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.notFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createVNode(_component_router_link, {
                to: "/liste-compositions",
                class: "btn btn-outline-primary mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Retour à la liste ")
                ]),
                _: 1
              })
            ]))
          : (_ctx.resultat && !_ctx.resultat.estCorrige)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.resultat.message || "Votre composition est en attente de correction par le professeur."), 1),
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("small", null, "Code session : " + _toDisplayString(_ctx.resultat.sessionCode), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/liste-compositions",
                  class: "btn btn-outline-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Retour à la liste ")
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.resultat)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.resultat.composition?.titre) + " — Résultat", 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["result-card", `result-${_ctx.niveau}`])
                      }, [
                        _hoisted_20,
                        _createElementVNode("p", {
                          class: _normalizeClass(["result-value", `text-${_ctx.niveau}`])
                        }, _toDisplayString(_ctx.resultat.score) + " / " + _toDisplayString(_ctx.resultat.total), 3)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["result-card", `result-${_ctx.niveau}`])
                      }, [
                        _hoisted_22,
                        _createElementVNode("p", {
                          class: _normalizeClass(["result-value", `text-${_ctx.niveau}`])
                        }, _toDisplayString(_ctx.resultat.percentage) + "%", 3)
                      ], 2)
                    ]),
                    (_ctx.resultat.composition?.type !== 'QuestionsReponses')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.resultat.correctAnswers), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.resultat.composition?.type !== 'QuestionsReponses')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.resultat.incorrectAnswers), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.resultat.dateExpire && !_ctx.resultat.estProfesseur)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _hoisted_33,
                        _hoisted_34,
                        _createElementVNode("p", _hoisted_35, [
                          _hoisted_36,
                          _createTextVNode(" Disponible après le : " + _toDisplayString(_ctx.resultat.dateFinSoumissionFormatee), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          (_ctx.resultat.composition?.type === 'QuestionsReponses')
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.resultat.questionsWithAnswers, (question, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: question.id,
                                  class: "question-review-item mb-15 border border-primary"
                                }, [
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, [
                                      _createElementVNode("h5", _hoisted_42, "Question " + _toDisplayString(index + 1), 1),
                                      _createElementVNode("span", _hoisted_43, _toDisplayString(question.note ?? 0) + " / " + _toDisplayString(question.bareme ?? '-'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("p", _hoisted_45, _toDisplayString(question.contenu), 1),
                                    _createElementVNode("div", _hoisted_46, [
                                      _hoisted_47,
                                      _createElementVNode("p", _hoisted_48, _toDisplayString(question.reponseTexte || "Non répondu"), 1)
                                    ]),
                                    (question.commentaire)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          _hoisted_50,
                                          _createElementVNode("p", _hoisted_51, _toDisplayString(question.commentaire), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.resultat.questionsWithAnswers, (question, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: question.id,
                                  class: _normalizeClass(["question-review-item mb-15 border", question.isCorrect ? 'border-success' : 'border-danger'])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["question-header px-15 py-10", question.isCorrect ? 'bg-success-subtle' : 'bg-danger-subtle'])
                                  }, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("h5", _hoisted_53, "Question " + _toDisplayString(index + 1), 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["status-icon", question.isCorrect ? 'text-success' : 'text-danger'])
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(["fa", question.isCorrect ? 'fa-check-circle' : 'fa-times-circle'])
                                        }, null, 2)
                                      ], 2)
                                    ])
                                  ], 2),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("p", _hoisted_55, _toDisplayString(question.contenu), 1),
                                    _createElementVNode("div", _hoisted_56, [
                                      _hoisted_57,
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["ms-2 fw-semibold", question.isCorrect ? 'text-success' : 'text-danger text-decoration-line-through'])
                                      }, _toDisplayString(_ctx.formatPropositions(question.userPropositions)), 3)
                                    ]),
                                    (!question.isCorrect)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          _hoisted_59,
                                          _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.formatPropositions(question.correctPropositions)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              }), 128))
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_61, [
                    (_ctx.peutRecommencer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("p", _hoisted_64, [
                            _createTextVNode(" Vous avez encore "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.resultat.tentativesRestantes), 1),
                            _createTextVNode(" essai(s) restant(s). ")
                          ]),
                          _hoisted_65
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_66, [
                      (_ctx.peutRecommencer)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.recommencer && _ctx.recommencer(...args))),
                            class: "btn btn-warning btn-action"
                          }, [
                            _hoisted_67,
                            _createTextVNode(" Recommencer (" + _toDisplayString(_ctx.resultat.tentativesRestantes) + " restant" + _toDisplayString(_ctx.resultat.tentativesRestantes > 1 ? 's' : '') + ") ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        to: "/liste-compositions",
                        class: "btn btn-primary btn-action"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_68,
                          _createTextVNode(" Retour à la liste ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
    ])
  ]))
}